global.$assets = "assets"
